import { AbstractAdManager, RewardedPlacement } from '../abstract/AbstractAdManager';
import { addSignal } from '../../../utils/EventUtils';
import { Events } from '../../Events';

export class GDAdManager extends AbstractAdManager {
    private rewardedRequested: boolean = false;
    private onAdcompleted: () => any;
    private onFail: (err: Error) => any;

    public async init(): Promise<void> {
        // @ts-ignore
        if (window.gdsdk !== 'undefined' && window.gdsdk.preloadAd !== 'undefined') {
            // @ts-ignore
            window.gdsdk
                .preloadAd('rewarded')
                .then(() => {
                    // A rewarded ad can be shown to user when he/she clicked it.
                })
                .catch(() => {
                    // Any Rewarded ad is not available to user.
                });
        }

        addSignal(this, Events.SDK_REWARDED_WATCH_COMPLETE, this.onRewardedComplete.bind(this));
        addSignal(this, Events.AD_ERROR, this.onRewardedFailed.bind(this));
        addSignal(this, Events.SKIPPED, this.onRewardedFailed.bind(this));

        return new Promise<void>((resolve: () => any, reject: () => any): any => {
            resolve();
        });
    }

    public showInterstitialAd(
        onAdCompleted: () => any,
    ): void {
        // @ts-ignore
        if (typeof window.gdsdk !== 'undefined' && window.gdsdk.showAd !== 'undefined') {
            // @ts-ignore
            window.gdsdk.showAd().then(() => {
                onAdCompleted();
            }).catch((e: any) => {
                onAdCompleted();
            });
        } else {
            onAdCompleted();
        }
    }

    public showRewardedAd(onAdCompleted: () => any, onFail: (err: Error) => any): void {
        if (!this.rewardedRequested) {
            // @ts-ignore
            if (typeof window.gdsdk !== 'undefined' && window.gdsdk.showAd !== 'undefined') {
                this.rewardedRequested = true;
                this.onAdcompleted = onAdCompleted;
                this.onFail = onFail;
                // @ts-ignore
                window.gdsdk.showAd('rewarded').then((result: any) => {
                    console.log('');
                }).catch((e: any) => {
                    onFail(e);
                });
            } else {
                onAdCompleted();
            }
        }
    }

    private onRewardedComplete(): void {
        if (this.rewardedRequested) {
            this.rewardedRequested = false;
            this.onAdcompleted();
            this.onAdcompleted = null;
            this.onFail = null;
        }
    }

    private onRewardedFailed(): void {
        if (this.rewardedRequested) {
            this.rewardedRequested = false;
            this.onFail(null);
            this.onAdcompleted = null;
            this.onFail = null;
        }
    }
}